import {Helmet} from '@dr.pogodin/react-helmet';
import {Action} from 'platform/components';

import {useMatch} from 'react-router-dom';

import {featureFlags} from '@dms/feature-flags';
import i18n from '@dms/i18n';
import {testIds, warehouseRoutes} from '@dms/routes';
import {Main, PageTab, usePermissions} from '@dms/shared';

import {buildArray, useNavigate} from 'shared/web';

import {PriceListInner} from './components/PriceListInner';
import {UpdateJobsList} from './components/UpdateJobsList';

export function PriceList() {
  const navigate = useNavigate();

  const [articleUpdateJobCreate] = usePermissions({
    permissionKeys: ['articleUpdateJobCreate'],
  });

  const isUpdateJobsListMatch = useMatch(warehouseRoutes.updateJobsList);

  const tabs = buildArray<PageTab>()
    .add({
      id: 'priceList',
      title: i18n.t('page.warehouse.labels.priceList'),
      content: <PriceListInner />,
      href: warehouseRoutes.priceList,
    })
    .whenFeatureEnabled(featureFlags.AFS_WAREHOUSE_ARTICLE_UPDATE_JOB, {
      id: 'updateJobs',
      title: i18n.t('page.warehouse.labels.updateJobs'),
      content: <UpdateJobsList />,
      href: warehouseRoutes.updateJobsList,
    });

  const actions = buildArray<Action>().when(isUpdateJobsListMatch, {
    type: 'button',
    title: i18n.t('entity.warehouse.labels.newJob'),
    isDisabled: !articleUpdateJobCreate,
    tooltip: !articleUpdateJobCreate
      ? i18n.t('module.warehouse.label.missingArticleUpdateJobCreatePermission')
      : undefined,
    onClick: () => navigate(warehouseRoutes.updateJobCreate),
  });

  return (
    <>
      <Helmet title={i18n.t('entity.warehouse.labels.priceList')} />
      <Main
        isFullHeight
        tabs={tabs}
        actions={actions}
        data-testid={testIds.warehouse.priceList('priceList')}
      />
    </>
  );
}
